export const sanitizedUrl = (url: string) =>
  url[url.length - 1] === '/' ? url.slice(0, -1) : url;
